import { Component, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { DeviceService } from '@app/services/device.service';
import { DeviceParameterFormComponent } from '@app/shared/device-parameter-form/device-parameter-form.component';
import { DeviceParameter } from '@app/store/device-parameter.model';
import { TuningController } from '@app/store/tuning-controller.model';

@Component({
  selector: 'app-torque-controller-tuning',
  templateUrl: './torque-controller-tuning.component.html',
  imports: [DeviceParameterFormComponent],
})
export class TorqueControllerTuningComponent {
  private deviceService = inject(DeviceService);

  @Input() title = 'Controller Tuning';

  pidParameters$: Observable<DeviceParameter[]>;

  private _tuningController: TuningController;

  @Input()
  set tuningController(tuningController: TuningController) {
    if (tuningController.id !== this.tuningController?.id) {
      this._tuningController = tuningController;
      this.pidParameters$ = this.deviceService.selectDeviceTorqueControllerPidParameters({
        serialNumber: tuningController.deviceSerialNumber,
      });
    }
  }

  get tuningController() {
    return this._tuningController;
  }
}
